import { Serializable } from '../../model/sidebar-query-params.model';

export class ArraySerializerBase<T> implements Serializable<T[]> {
  private static readonly separator = ',';

  deserialize(value: string): T[] {
    const list = value.split(ArraySerializerBase.separator) as T[];
    return list;
  }

  serialize(value: T[]): string {
    return value.join(ArraySerializerBase.separator);
  }
}
